import { render, staticRenderFns } from "./test-report.vue?vue&type=template&id=3b48fc14&scoped=true&"
import script from "./test-report.vue?vue&type=script&lang=js&"
export * from "./test-report.vue?vue&type=script&lang=js&"
import style0 from "./test-report.vue?vue&type=style&index=0&id=3b48fc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48fc14",
  null
  
)

export default component.exports